import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { manageusersData } from "../../../core/data/json/manageuser";
import { TableData } from "../../../core/data/interface";
import PredefinedDateRanges from "../../../core/common/datePicker";
import CommonSelect from "../../../core/common/commonSelect";
import { Reason } from "../../../core/common/selectoption/selectoption";
import { all_routes } from "../../router/all_routes";
import TooltipOption from "../../../core/common/tooltipOption";
import { PageBreadcrumb } from "../../../core/common/BreadCrumbForm";
import Datatable from "../../../core/common/dataTable/index";
import { ColumnsType } from "antd/es/table";
import { parseNumber, safeLocaleCompare } from "../../../core/methods/sorterMethods";
import { dummydata_users } from "../../../core/data/js/dummy-data";
import { cellWidth } from "../../../core/methods/tableCellWidth";

// breadcrumb data
const breadcrumbItem = [
  { label: "Manage User" },
];

const AccountManageUser = () => {
  const [allItemList, setAllItemList] = useState<any[]>(dummydata_users)

  const columns: ColumnsType<any> = [
    {
      title: "S.No",
      dataIndex: "sno",
      align: 'center',
      // render: (text: string, record: any, index: number) => index + 1,
      sorter: false,
    },
    {
      title: "User Name",
      dataIndex: "user_name",
      sorter: (a: any, b: any) => safeLocaleCompare(a, b, "user_name"),
    },
    {
      title: "Email",
      dataIndex: "email",
      width: 180,
      render: (text: string) => <div className="text-break">{text}</div>,
      sorter: (a: any, b: any) => safeLocaleCompare(a, b, "email"),
    },
    {
      title: "Contact",
      dataIndex: "contact",
      sorter: (a: any, b: any) => parseNumber(a.contact) - parseNumber(b.contact),
    },
    {
      title: "User Type",
      dataIndex: "user_type",
      sorter: (a: any, b: any) => safeLocaleCompare(a, b, "user_type"),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => (
        <>
          {text === "Active" ? (
            <span className="badge badge-soft-success d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              {text}
            </span>
          ) : (
            <span className="badge badge-soft-danger d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              {text}
            </span>
          )}
        </>
      ),
      sorter: (a, b) => safeLocaleCompare(a, b, "status"),
    },
    {
      title: "Action",
      dataIndex: "",
      render: (text: string) => (
        <>
          <button type="button" className="btn btn-tertiary btn-sm">
            Change Profile
          </button>
        </>
      ),
    },
  ];

  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  return (
    <div>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* PageBreadcrumb */}
            <PageBreadcrumb
              title="Manage User"
              breadcrumbs={breadcrumbItem}
            // showExport={true}
            />
            {/* /PageBreadcrumb */}

            {/* Table */}
            <div className="card mt-4">
              <Datatable
                columns={columns}
                dataSource={allItemList}
                Selection={false}
              />
            </div>

            {/* /Filter Section */}
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="datatable-paginate mt-4" />
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>
    </div>
  );
};

export default AccountManageUser;

// {/* Filter Section */}
// <div className="card">
//   <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
//     <h4 className="mb-3">Users List</h4>
//     <div className="d-flex align-items-center flex-wrap">
//       <div className="input-icon-start mb-3 me-2 position-relative">
//         <PredefinedDateRanges />
//       </div>
//       <div className="dropdown mb-3 me-2">
//         <Link
//           to="#"
//           className="btn btn-outline-light bg-white dropdown-toggle"
//           data-bs-toggle="dropdown"
//           data-bs-auto-close="outside"
//         >
//           <i className="ti ti-filter me-2" />
//           Filter
//         </Link>
//         <div
//           className="dropdown-menu drop-width"
//           ref={dropdownMenuRef}
//         >
//           <form>
//             <div className="d-flex align-items-center border-bottom p-3">
//               <h4>Filter</h4>
//             </div>
//             <div className="p-3 border-bottom">
//               <div className="row">
//                 <div className="col-md-12">
//                   <div className="mb-0">
//                     <label className="form-label">Users</label>
//                     <CommonSelect
//                       className="select"
//                       options={Reason}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="p-3 d-flex align-items-center justify-content-end">
//               <Link to="#" className="btn btn-light me-3">
//                 Reset
//               </Link>
//               <Link
//                 to="#"
//                 className="btn btn-primary"
//                 onClick={handleApplyClick}
//               >
//                 Apply
//               </Link>
//             </div>
//           </form>
//         </div>
//       </div>
//       <div className="dropdown mb-3">
//         <Link
//           to="#"
//           className="btn btn-outline-light bg-white dropdown-toggle"
//           data-bs-toggle="dropdown"
//         >
//           <i className="ti ti-sort-ascending-2 me-2" />
//           Sort by A-Z
//         </Link>
//         <ul className="dropdown-menu p-2">
//           {["Ascending", "Descending", "Recently Viewed", "Recently Added"]?.map((d) => (
//             <li className="p-1">
//               <Link to="#" className={`dropdown-item rounded-1 active p-1`}>
//                 {d}
//               </Link>
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   </div>
//   {/* User List */}
//   <div className="card-body p-0 py-3">
//     <Table columns={columns} dataSource={data} Selection={true} />
//   </div>
//   {/* /User List */}
// </div>